import React, {Component} from 'react'
import {connect} from 'react-redux'

class FinalResultsDemoStep extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div><b>You can view your results here</b></div>
                <div>You can save results to further ask questions</div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(FinalResultsDemoStep)